import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_MemberOrientationForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_MemberOrientationForm' className='file-pdf-document'>
            <div className='file-template'>




                <p className='w-750'> <center> Member Orientation Form </center> </p>
                <p className='w-750'>
                    As a member, parent, or legal guardian of a member of Restore Outreach Center, you can expect to be instructed or given written information regarding the following, upon admission to Restore Outreach Center's Mental Health Program

                </p>

                <p className='w-750'>
                    <ol>
                        <li> Member Rights and Responsibilities</li>
                        <li> Grievance and Appeal Procedures</li>
                        <li> Communication/input policies regarding:
                            <ol type='a'>
                                <li> Quality of care</li>
                                <li> Outcome achievement</li>
                                <li> Member satisfaction</li>
                            </ol>
                        </li>
                        <li>
                            Explanation of Restore Outreach Center's
                            <ol type='a'>
                                <li> Mission/philosophy</li>
                                <li> Services, activities, and therapeutic interventions</li>
                                <li> Expectations</li>
                                <li> Hours of operation</li>
                                <li> 24-hour on call policy</li>
                                <li> Code of ethics</li>
                                <li> Confidentiality policy</li>
                                <li> Requirements for follow-up for mandated members, regardless of his/her discharge outcome.</li>
                            </ol>
                        </li>
                        <li> Explanation of any and all financial obligations, fees, and arrangements for services provided by the organization.</li>
                        <li> Orientation with Restore Outreach Center facilities, including emergency exits, fire suppression equipment, and first aid kits.</li>
                        <li> Restore Outreach Center policies regarding.
                            <ol type='a'>
                                <li> Smoking</li>
                                <li> Illicit or licit drugs</li>
                                <li> Weapons</li>
                                <li> Abuse</li>
                            </ol>
                        </li>
                        <li> Identification of service coordinator</li>
                        <li> Program rules that identify:

                            <ol type='a'>
                                <li> Any restrictions the program may place on members.</li>
                                <li> Events, behaviors, or attitudes that may lead to the loss of rights or privileges that have been restricted.</li>
                            </ol>
                        </li>
                        <li> Education regarding Advanced Directives, where appropriate</li>
                        <li> Identification of the purpose and process assessment</li>
                        <li> A description of how the treatment plan will be developed.</li>
                        <li> information regarding transition of criteria and procedures</li>
                    </ol>
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Client/Parent or Legal Guardian Print </td>
                        <td className='small w-250'> Client/Parent or Legal Guardian Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}